import { type ThemeConfig } from "antd";

export const brandPrimary = "#2D53C8";

export const rootTheme: ThemeConfig = {
  token: {
    colorPrimary: brandPrimary,
  },
};
